import merge from 'deepmerge';

import type { Translations } from '../types';
import common from './common';
import customer from './customer';
import de from './de/mobile.json';
import deAT from './de-AT/mobile.json';
import deCH from './de-CH/mobile.json';
import en from './en/mobile.json';
import fr from './fr/mobile.json';
import frCH from './fr-CH/mobile.json';

const mobile = {
  fr: fr.mobile,
  en: en.mobile,
  de: de.mobile,
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'fr-CH': merge(fr.mobile, frCH.mobile || {}),
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'de-CH': merge(de.mobile, deCH.mobile || {}),
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'de-AT': merge(de.mobile, deAT.mobile || {}),
};

export default merge.all<Translations>([common, customer, mobile]);
